import React from 'react';
import Input from '../../../../shared/components/Input';
import { IInput } from '../../../../shared/interfaces/inputs';

function UserInput(props: IInput) {
  return (
    <Input.Default onChange={props.onChange} name={props.name} type="text" />
  );
}

export default UserInput;
